import styled from 'styled-components'

// Utils
import { breakpoint } from 'utils/breakpoint'

export const Wrapper = styled.div`
  display: flex;
  gap: 40px;
  margin: 0 0 40px 0;

  ${breakpoint('base', 'xl')`
    flex-wrap: wrap;
  `}

  ${breakpoint('base', 'md')`
    gap: 16px;
  `}

  ${breakpoint('base', 'xs')`
    flex-direction: column;
  `}
`

export const Icon = styled.img`
  max-width: 100%;
  height: auto;
`
